module.exports = __webpack_public_path__ + "media/assets/images/confinus-avatar-black-9b7853698c14f05eb1ab4e962976ca64.png";